import { latestItemForFeed } from "@/store/feedSelectors";
import type { DispatchTableRow } from "./dispatchTableRow";

/** A message the member has just been shown and has not read: what a `Read Feed Item` receipt names. */
export type UnreadShownMessage = { feedId: string; itemId: string };

/**
 * The driver's message a highlighted row shows in its Message cell, when the member has not read it yet: the row's own
 * message on a message row (every message row is the driver's), the driver's latest message on a driver row. Null
 * when the row shows nothing of the driver's (a channel with no traffic), shows a required TMS event or a task pinned
 * to another board instead of a message, or the member has already read it, so the caller sends a receipt only for a
 * reading that happened.
 */
export function unreadMessageShownBy(row: DispatchTableRow): UnreadShownMessage | null {
  if (row.kind === "message") {
    return row.item.unread ? { feedId: row.item.feedId, itemId: row.item.id } : null;
  }
  // A task row about a message shows that message; one about a driver or an event shows no message of its own.
  if (row.kind === "task") {
    const item = row.item;
    return item?.source === "message" && item.unread ? { feedId: item.feedId, itemId: item.id } : null;
  }
  const feedId = row.driver.feedId;
  if (!feedId || row.driver.recentSource === "tmsEvent" || row.driver.recentSource === "otherBoardTask") return null;
  const latest = latestItemForFeed(feedId, (item) => item.isFromAliasMember === true);
  return latest?.unread === true ? { feedId, itemId: latest.id } : null;
}
